import type { ClusterQA } from "@/lib/qa/cluster-pages";

type BusinessLike = { slug: string; q: string; a: string; synonyms: string[]; serviceSlug?: string };
type ServiceLike = { slug: string; nameTh: string };

/**
 * Map a business-cluster Q&A list (corporate / accounting) onto the shared
 * ClusterQA shape so the topic sub-hub renderer can group ~1,000 questions
 * into per-service buckets instead of one giant link list.
 */
export function businessQaAsCluster(qa: BusinessLike[], services: readonly ServiceLike[]): ClusterQA[] {
  const label = new Map(services.map((s) => [s.slug, s.nameTh]));
  return qa.map((item) => ({
    slug: item.slug,
    q: item.q,
    a: item.a,
    synonyms: item.synonyms,
    topicSlug: item.serviceSlug && label.has(item.serviceSlug) ? item.serviceSlug : "general",
    topicTh: (item.serviceSlug && label.get(item.serviceSlug)) || "คำถามทั่วไป",
  }));
}
